import { Document } from "@react-pdf/renderer"
import FrontPage from "./FrontPage"
import { getAnsweredQuestions, QuestionData } from "../../config/questions"
import { QuestionsPage } from "./QuestionsPage"

type ReportProps = {
  questions: QuestionData[]
  score: number
  frontTitle: string
  indicatorText: string
  poorText: string
  goodText: string
}

export const Report = ({
  questions,
  score,
  frontTitle,
  indicatorText,
  poorText,
  goodText,
}: ReportProps) => {
  const filteredQuestions = getAnsweredQuestions(questions)

  return (
    <Document>
      <FrontPage title={frontTitle} />

      {filteredQuestions.length > 0 ? (
        <QuestionsPage
          questions={filteredQuestions}
          score={score}
          indicatorText={indicatorText}
          poorText={poorText}
          goodText={goodText}
        />
      ) : null}
    </Document>
  )
}
